// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wf-promo[data-v-114f291a]{background-image:linear-gradient(135deg,#fac9da 23.08%,#ffeec2 0,#ffeec2 30.77%,#fab9cf 0,#fab9cf 50%,#fac9da 0,#fac9da 73.08%,#ffeec2 0,#ffeec2 80.77%,#fab9cf 0,#fab9cf);background-size:183.85px 183.85px}", ""]);
// Exports
module.exports = exports;
